export const REFERRAL_MEMO_CREATE_REQUESTED = 'REFERRAL_MEMO_CREATE_REQUESTED';
export const REFERRAL_MEMO_CREATE_SUCCEED = 'REFERRAL_MEMO_CREATE_SUCCEED';
export const REFERRAL_MEMO_CREATE_FAILED = 'REFERRAL_MEMO_CREATE_FAILED';

export const REFERRAL_MEMO_PREVIEW_REQUESTED = 'REFERRAL_MEMO_PREVIEW_REQUESTED';
export const REFERRAL_MEMO_PREVIEW_SUCCEED = 'REFERRAL_MEMO_PREVIEW_SUCCEED';
export const REFERRAL_MEMO_PREVIEW_FAILED = 'REFERRAL_MEMO_PREVIEW_FAILED';

export const REFERRAL_MEMOS_GET_REQUESTED = 'REFERRAL_MEMOS_GET_REQUESTED';
export const REFERRAL_MEMOS_GET_SUCCEED = 'REFERRAL_MEMOS_GET_SUCCEED';
export const REFERRAL_MEMOS_GET_FAILED = 'REFERRAL_MEMOS_GET_FAILED';
